import { ja } from 'date-fns/locale/ja';
import ReactDatePicker, { registerLocale } from 'react-datepicker';
import { Controller, get, useWatch } from 'react-hook-form';

import { useEffect, type JSX } from 'react';
import 'react-datepicker/dist/react-datepicker.css';

/**
 * テキストフィールド基本コンポーネント
 */

registerLocale('ja', ja);

export default function FormDatePicker(props: {
  // タイトル
  subject?: string;
  // name属性
  name: string;
  // プレースホルダー
  placeholder?: string;
  // 必須検証の有無
  required?: boolean;
  // 必須/任意のアイコン表示有無
  requiredMark?: boolean;
  // 読み取り専用
  readOnly?: boolean;
  // クラス名
  className?: string;
  // フォームコントロール
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: any;
  // 日付フォーマット
  dateFormat?: string;
  // エラー情報
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errors: any;
  // 開始日
  startDate?: Date;
  // 終了日
  endDate?: Date;
}): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const value = useWatch({
    control: props.control,
    name: props.name,
  });

  useEffect(() => {
    console.debug('datevalue', value);
  }, [value]);
  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */

  return (
    <>
      <Controller
        name={props.name}
        control={props.control}
        defaultValue={null}
        rules={
          props.required
            ? {
                required: '必須項目です。',
              }
            : {}
        }
        render={({ field }) => {
          return (
            <>
              {props.subject && (
                <label htmlFor="descriptionHtml" className="form-label">
                  {props.subject}
                </label>
              )}
              <ReactDatePicker
                locale={ja}
                className={`form-control ${props.className}`}
                placeholderText={props.placeholder}
                selected={value || null}
                onChange={field.onChange}
                dateFormat={props.dateFormat || 'yyyy/MM/dd'}
                selectsStart
                startDate={props.startDate}
                selectsEnd
                endDate={props.endDate}
              />
              {get(props.errors, props.name) && (
                <p className="error">{get(props.errors, props.name)?.message}</p>
              )}
            </>
          );
        }}
      />
    </>
  );
}
